module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxtDawAUxQv-nqIa2sHgh1E4.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/PRmiXeptR36kaC0GEAetxtDawAUxQv-nqIa2sHgh1E4.woff2
// module id = 416
// module chunks = 0